import PageForgotPasswordSet from "./PageForgotPasswordSet.vue";
export default PageForgotPasswordSet;
